import Immutable from 'immutable'
import moment from 'moment'

const fields = {
  attributes: Immutable.Set(),
  availableFrom: null,
  availableUntil: null,
  bandwidthPacks: Immutable.Set(), // ID, not whole pack
  contractLength: null,
  displayOrder: null,
  features: Immutable.OrderedSet(),
  id: null,
  minimumSpend: 0,
  name: '',
  period: null,
  product: null, // ID, not whole product
  recurringAmount: 0,
  replacedBy: null, // ID, not whole offer
  setupAmount: 0,
  sla: null,
  speed: null,
  uniqueId: '',
  upgradeGroup: null,
}

export class OfferRecord extends Immutable.Record(fields, 'Offer') {
  constructor({
    attributes = [],
    availableFrom,
    availableUntil,
    bandwidthPacks = [],
    contractLength,
    features = [],
    period,
    product,
    replacedBy,
    sla,
    ...data
  } = {}) {
    super({
      ...data,
      attributes: Immutable.Set(attributes),
      availableFrom: availableFrom ? moment(availableFrom) : null,
      availableUntil: availableUntil ? moment(availableUntil) : null,
      bandwidthPacks: Immutable.Set(bandwidthPacks.map(p => p.id)),
      contractLength: contractLength ? moment.duration(contractLength) : null,
      features: Immutable.OrderedSet(features),
      period: period ? moment.duration(period) : null,
      product: product ? product.id : null,
      replacedBy: replacedBy ? replacedBy.id : null,
      sla: sla ? moment.duration(sla) : null,
    })
  }

  equals(other) {
    return this.id === other.id
  }

  hashCode() {
    return Immutable.hash(this.id)
  }
}

export default data => new OfferRecord(data)




// WEBPACK FOOTER //
// ./deps/internal-components/src/records/Offer.js